import dynamic from 'next/dynamic';

export const SearchFeedbackDynamic = dynamic(
  () =>
    import(/* webpackChunkName: 'SearchFeedback' */ './SearchFeedback.client').then(
      (mod) => mod.SearchFeedback,
    ),
  { ssr: false },
);
